import { useEffect } from 'react';
import { useSupabaseAuth } from '@/hooks/auth';
import { CourseCompletionWatcher } from '@/services/courseCompletionWatcher';
import { useQueryClient } from '@tanstack/react-query';

export const useCourseCompletionWatcher = (courseId: string | undefined) => {
  const { user } = useSupabaseAuth();
  const queryClient = useQueryClient();
  
  useEffect(() => {
    if (!user || !courseId) return;
    
    const handleCompletion = () => {
      // Invalidate relevant queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['course-assignments'] });
      queryClient.invalidateQueries({ queryKey: ['certificates'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
      queryClient.invalidateQueries({ queryKey: ['course-progress', courseId] });
    };
    
    const unwatch = CourseCompletionWatcher.watchCourseProgress(
      user.id, 
      courseId, 
      handleCompletion
    );
    
    return () => {
      if (unwatch) {
        unwatch();
      }
    };
  }, [user, courseId, queryClient]);
};
